import FakeExemplarySolutionModal from './fake-exemplary-solution-modal'

export default FakeExemplarySolutionModal
